import React, { useEffect } from "react";

const FloodlightPixel = () => {
    useEffect(() => {
        const noscript = document.createElement('noscript');
        var axel = Math.random() + "";
        var a = axel * 10000000000000;
        var src = `https://6201950.fls.doubleclick.net/activityi;src=6201950;type=audi_0;cat=mx_au00f;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=${a}?`;

        const iframe = document.createElement('iframe');

        iframe.src = src;
        iframe.width = "1";
        iframe.height = "1";
        iframe.frameBorder = "0";
        iframe.style.display = "none";

        noscript.id = "flood-light-pixel-iframe";
        noscript.textContent = `
            <iframe src="https://6201950.fls.doubleclick.net/activityi;src=6201950;type=audi_0;cat=mx_au00f;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameborder="0" style="display:none"></iframe>
        `

        document.body.appendChild(iframe);
        document.body.appendChild(noscript);

    }, []);

    return (
        <></>
    );
};

export default FloodlightPixel;